import { Link } from "@/components/Link";
import {
  LeftIcon,
  RightIcon,
  SuggestionItem,
  SuggestionText,
} from "@/components/Search/SearchSuggestionList/style";
import type { SuggestionProps } from "@/components/Search/SearchSuggestionList/types";
import { SvgArrowUpRight, SvgMagnifyingGlass } from "@getgrover/ui";

const highlightMatch = (suggestion: string, query: string) => {
  if (!query) return suggestion;

  const regex = new RegExp(`(${query})`, "gi");
  const parts = suggestion.split(regex);

  return parts.map((part, index) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <mark key={`${index}-${part}`}>{part}</mark>
    ) : (
      part
    ),
  );
};

export const SearchSuggestionItem = ({
  suggestion,
  query,
}: SuggestionProps) => {
  const content = (
    <>
      <LeftIcon>
        <SvgMagnifyingGlass />
      </LeftIcon>
      <SuggestionText>{highlightMatch(suggestion, query)}</SuggestionText>
      <RightIcon>
        <SvgArrowUpRight />
      </RightIcon>
    </>
  );

  return (
    <SuggestionItem>
      <Link href={`/search/${suggestion}`}>{content}</Link>
    </SuggestionItem>
  );
};
